import React from "react";

export const SuccussIcon = () => {
  return (
    <>
      <svg
        width="84"
        height="84"
        viewBox="0 0 84 84"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_872_2305)">
          <circle
            cx="42"
            cy="38"
            r="36"
            fill="#23A26D"
            style={{
              fill: "#23A26D",
              fill: "color(display-p3 0.1373 0.6353 0.4275)",
              fillOpacity: 1,
            }}
          />
        </g>
        <path
          d="M30.2168 39.5709L40.8224 48.0968L55.2157 27.7852"
          stroke="white"
          style={{ stroke: "white", strokeOpacity: 1 }}
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <filter
            id="filter0_d_872_2305"
            x="0.3"
            y="0.3"
            width="83.4"
            height="83.4"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2.85" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_872_2305"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_872_2305"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </>
  );
};
